export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Unidad de medida',
	plural_model_name_spanish: 'Unidades de medida',
	create_model_name_spanish: 'Nueva Unidad de medida',
	text_delete: 'la',
}